export default "__VITE_ASSET__14b2b8e3__"